<template>
    <div id="d-group-booking-detail">
        <div class="grid pb-0">
            <div class="grid-title">
                <h4 class="mr-auto">{{ $t("_GROUP.DETAIL_BOOKING") }}</h4>
                <v-btn class="mt-0" depressed color="primary" v-if="code" @click="() => { $emit('close') }">
                    {{ $t("CLOSE") }}
                </v-btn>
                <v-btn class="mt-0" depressed color="warning" v-if="!code" @click="$router.back()">
                    <i class="icon-back-ic mr-2"></i>{{ $t("BACK") }}
                </v-btn>
                <v-btn class="mt-0 ml-3" color="primary" depressed @click="editProfile()">
                    <i class="icon-edit mr-2"></i>{{ $t("EDIT") }}
                </v-btn>
            </div>
            <div class="grid-body border-top-unset list-booking-group">
                <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
                <div class="p-3" v-if="!isLoading">
                    <div class="d-flex align-items-stretch">
                        <div class="w-100">

                            <v-card class="p-3 h-100 border" elevation="0">
                                <label class="label-title">{{ $t("_GROUP.INFO") }}</label>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_BOOKING_GROUP.GROUP_PROFILE_NAME")
                                    }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.nameVi }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_BOOKING_GROUP.GROUP_PROFILE_CODE")
                                    }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.bookingGroupProfileCode }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_GROUP.COMPANY_NAME") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.company }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_REGISTER.WEBSITE") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.website }}</v-col>
                                </v-row>
                            </v-card>
                        </div>
                        <!-- <v-divider vertical style="margin: 0 5px !important"></v-divider> -->
                        <div class="w-100 ml-3">

                            <v-card class="p-3 h-100 border" elevation="0">
                                <label class="label-title">{{ $t("_BOOKING_DETAIL.CONTACT.TITLE") }}</label>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_GROUP.CONTACT_NAME") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.contactName }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_GROUP.PHONE_NUMBER") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.contactPhone
                                    }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_GROUP.PHONE_NUMBER_OTHER") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.contactMobile
                                    }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">Email</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.contactEmail
                                    }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("ADDRESS") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.contactAddress
                                    }}</v-col>
                                </v-row>
                            </v-card>
                        </div>
                        <!-- <v-divider vertical style="margin: 0 5px !important"></v-divider> -->
                        <div class="w-100 ml-3">

                            <v-card class="p-3 h-100 border" elevation="0">
                                <label class="label-title">{{ $t("_GROUP.INFO_MANAGE") }}</label>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_GROUP.MANAGE_NAME") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.managerName }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_GROUP.PHONE_NUMBER") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.managerPhone
                                    }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_GROUP.PHONE_NUMBER_OTHER") }}</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.managerMobile
                                    }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0 text-primary" cols="5">Email</v-col>
                                    <v-col class="pb-0">{{ detailData.bookingGroupProfile.managerEmail
                                    }}</v-col>
                                </v-row>
                            </v-card>
                        </div>
                    </div>
                    <div class="d-flex mt-4">
                        <v-row>
                            <v-col cols="8">
                                <v-card class="p-3 flex-grow-1 border h-100" elevation="0">
                                    <label class="label-title">{{ $t("_GROUP.GROUP_INFO") }}</label>
                                    <div class="d-flex pt-3">
                                        <div class="w-100">
                                            <div class="w-100">
                                                <v-row>
                                                    <v-col class="py-0 text-primary" cols="5">{{
                                                        $t("_BOOKING_GROUP.BOOKING_GROUP_NAME")
                                                    }}</v-col>
                                                    <v-col class="py-0">{{ detailData.nameVi }}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">{{
                                                        $t("_BOOKING_GROUP.BOOKING_GROUP_CODE")
                                                    }}</v-col>
                                                    <v-col class="pb-0">{{ detailData.bookingGroupCode }}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">{{ $t("_GROUP.PMS_CCODE") }}</v-col>
                                                    <v-col class="pb-0">{{ detailData.externalGroupCode }}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">{{
                                                        $t('_GROUP.CUT_OF_DATE') }}</v-col>
                                                    <v-col class="pb-0">
                                                        <template v-if="systemLang == 'vi'">
                                                            {{ _formatDateTime(detailData.cutOffDate, "YYYY-MM-DD",
                                                                "DD/MM/YYYY HH: mm: ss") }}
                                                        </template>
                                                        <template v-else>
                                                            {{
                                                                _formatDateTime(detailData.cutOffDate, "YYYY-MM-DD",
                                                                    "YYYY/MM/DD HH: mm: ss") }}
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">{{
                                                        $t('_GROUP.CUS_OF_DAYS') }}</v-col>
                                                    <v-col class="pb-0">{{ detailData.cutOffDay }}</v-col>
                                                </v-row>
                                            </div>
                                        </div>
                                        <v-divider vertical style="margin: 0 15px !important"></v-divider>
                                        <div class="w-100">
                                            <div>
                                                <v-row>
                                                    <v-col class="py-0 text-primary" cols="5">{{ $t("_BOOKING_GROUP.STATUS")
                                                    }}</v-col>
                                                    <v-col class="py-0 font-weight-bold">{{ listStatus.find(x => x.value ==
                                                        detailData.bookingGroupStatus).text }}</v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">{{
                                                        $t("_BOOKING_GROUP.BOOKING_GROUP_CREATE_DATE") }}</v-col>
                                                    <v-col class="pb-0">
                                                        <template v-if="systemLang == 'vi'">
                                                            {{
                                                                _formatDateTime(detailData.createdDate, "YYYY-MM-DD",
                                                                    "DD/MM/YYYY HH: mm: ss")
                                                            }}
                                                        </template>
                                                        <template v-else>
                                                            {{
                                                                _formatDateTime(detailData.createdDate, "YYYY-MM-DD",
                                                                    "YYYY/MM/DD HH: mm: ss")
                                                            }}
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">{{
                                                        $t("_BOOKING_GROUP.BOOKING_GROUP_START_DATE") }}</v-col>
                                                    <v-col class="pb-0">
                                                        <template v-if="systemLang == 'vi'">
                                                            {{
                                                                _formatDateTime(detailData.arrival, "YYYY-MM-DD", "DD/MM/YYYY")
                                                            }}
                                                        </template>
                                                        <template v-else>
                                                            {{
                                                                _formatDateTime(detailData.arrival, "YYYY-MM-DD", "YYYY/MM/DD")
                                                            }}
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">{{
                                                        $t("_BOOKING_GROUP.BOOKING_GROUP_END_DATE")
                                                    }}</v-col>
                                                    <v-col class="pb-0">
                                                        <template v-if="systemLang == 'vi'">
                                                            {{
                                                                _formatDateTime(detailData.departure, "YYYY-MM-DD", "DD/MM/YYYY")
                                                            }}
                                                        </template>
                                                        <template v-else>
                                                            {{
                                                                _formatDateTime(detailData.departure, "YYYY-MM-DD", "YYYY/MM/DD")
                                                            }}
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">{{
                                                        $t("_BOOKING_DETAIL.BOOKING_DETAIL.NOTE")
                                                    }}</v-col>
                                                    <v-col class="pb-0">
                                                        {{ detailData.descriptionVi }}
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                            <v-col cols="4">
                                <v-card class="p-3 border h-100" elevation="0">
                                    <label class="label-title">{{ $t("_GROUP.PAYMENT_INFO") }}</label>
                                    <div class="d-flex pt-3">
                                        <div class="w-100">
                                            <div class="w-100">
                                                <v-row>
                                                    <v-col class="py-0 text-primary" cols="5">{{
                                                        $t("_GROUP.TOTAL") }}
                                                    </v-col>
                                                    <v-col class="py-0">
                                                        {{ formatCurrency(detailData.amountPax) }}
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">
                                                        {{ $t("_GROUP.PAYMENT_METHOD") }}
                                                    </v-col>
                                                    <v-col class="pb-0">
                                                        {{ detailData.paymentMethod.map(e => e).join(", ") }}
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col class="pb-0 text-primary" cols="5">
                                                        {{ $t("_GROUP.PAYMENT_METHOD_BOOKING_RETAIL") }}
                                                    </v-col>
                                                    <v-col class="pb-0">
                                                        {{ listPaymentMethod.find(e => e.value === detailData.bookingGroupPaymentType).text }}
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider></v-divider>
                    <label class="label-title">{{ $t("_GROUP.BOOKING_GROUP_INFO") }}</label>
                    <v-data-table :headers="dessertHeaders" :items="detailData.bookingGroupDTOS" :single-expand="false"
                        hide-default-footer :expanded.sync="expanded" item-key="bookingGroupCode" show-expand
                        class="elevation-1 mt-3">
                        <template v-slot:item.stt="{ item, index }">
                            {{ (index + 1) }}
                        </template>
                        <template v-slot:item.arrival="{ item, index }">
                            <template v-if="systemLang == 'vi'">
                                {{
                                    _formatDateTime(item.arrival, "YYYY-MM-DD", "DD/MM/YYYY")
                                }}
                            </template>
                            <template v-else>
                                {{
                                    _formatDateTime(item.arrival, "YYYY-MM-DD", "YYYY/MM/DD")
                                }}
                            </template>
                        </template>
                        <template v-slot:item.departure="{ item, index }">
                            <template v-if="systemLang == 'vi'">
                                {{ _formatDateTime(item.departure, "YYYY-MM-DD", "DD/MM/YYYY") }}
                            </template>
                            <template v-else>
                                {{ _formatDateTime(item.departure, "YYYY-MM-DD", "YYYY/MM/DD") }}
                            </template>
                        </template>
                        <template v-slot:item.cutOffDate="{ item, index }">
                            <template v-if="item.cutOffDate">
                                <template v-if="systemLang == 'vi'">
                                    {{ _formatDateTime(item.cutOffDate, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                </template>
                                <template v-else>
                                    {{ _formatDateTime(item.cutOffDate, "YYYY-MM-DD", "YYYY/MM/DD") }}
                                </template>
                            </template>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length">
                                <template>
                                    <v-data-table :headers="headerSub" :items="item.bookingDTOS" class="elevation-sub"
                                        hide-default-footer>
                                        <template v-slot:item.stt="{ item, index }">
                                            {{ (index + 1) }}
                                        </template>
                                        <template v-slot:item.bookingCustomer="{ item, index }">
                                            <a class="app-link text-decoration-none" href="javascript:;"
                                                @click="goToBookingDetail(item.bookingCode)">
                                                {{
                                                    item.bookingCustomer.name + ' ' + item.bookingCustomer.surname
                                                }}
                                            </a>
                                        </template>
                                        <template v-slot:item.timeStay="{ item, value, index }">
                                            <template v-if="systemLang == 'vi'">
                                                {{
                                                    _formatDateTime(item.arrival, "YYYY-MM-DD", "DD/MM/YYYY")
                                                }} <br>
                                                {{ _formatDateTime(item.departure, "YYYY-MM-DD", "DD/MM/YYYY") }}
                                            </template>
                                            <template v-else>
                                                {{
                                                    _formatDateTime(item.arrival, "YYYY-MM-DD", "YYYY/MM/DD")
                                                }} <br>
                                                {{ _formatDateTime(item.departure, "YYYY-MM-DD", "YYYY/MM/DD") }}
                                            </template>
                                        </template>
                                        <template v-slot:item.totalAmount="{ item, index }">
                                            {{ formatCurrency(item.amount, item.currencyCode) }}
                                        </template>
                                        <template v-slot:item.bookingStatus="{ item, index }">
                                            <span
                                                :style="{ color: listBookingStatus.find(x => x.value == item.bookingStatus).color }">
                                                {{
                                                    listBookingStatus.find(x => x.value == item.bookingStatus).text
                                                }}
                                            </span>
                                        </template>
                                        <template v-slot:item.checkInStatus="{ item, index }">
                                            {{
                                                item.checkinStatus !== null ? listCheckinStatus.find(x => +x.value ==
                                                    +item.checkinStatus
                                                ).text : item.checkinStatus
                                            }}
                                        </template>
                                        <template v-slot:item.bookingDate="{ item, index }">
                                            {{ formatDateTime(item.createdDate) }}
                                        </template>
                                        <template v-slot:item.syncPms="{ item, index }">
                                            <template v-if="item.pmsCode">
                                                <v-menu bottom left>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn depressed :color="item.channelStatus === 1 ? 'success' : ''"
                                                            x-small v-bind="attrs" v-on="on" class="rounded-sm  mr-1"
                                                            outlined>
                                                            <i class="icon-more_vert fs-18 cursor font-weight-bold"></i>
                                                        </v-btn>
                                                    </template>

                                                    <div class="d-flex bg-white p-2">
                                                        <div class="mr-3">
                                                            <p v-if="item.channelStatus === 1" class="m-0 pr-3">
                                                                <span class="text-success">{{
                                                                    $t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED')
                                                                }}</span>
                                                                <br>
                                                                <span class="fs-12">{{
                                                                    formatDateTime(item.channelTime)
                                                                }}</span>
                                                            </p>
                                                            <p v-else class="m-0 pr-3">
                                                                {{ $t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED') }}
                                                            </p>
                                                        </div>
                                                        <div class="text-right">
                                                            <p class="mb-0">{{ item.pmsCode.split(',').map(e =>
                                                                $t(e)).join(", ") }}</p>
                                                            <v-btn color="success" x-small
                                                                @click.stop="openPopupReSync(item)"><small>{{
                                                                    $t('RE_SYNC') }}</small></v-btn>
                                                        </div>
                                                    </div>
                                                </v-menu>
                                            </template>
                                        </template>
                                        <template v-slot:no-data>
                                            <div class="text-center">{{ $t('$vuetify.noDataText') }}</div>
                                        </template>
                                    </v-data-table>
                                </template>
                            </td>
                        </template>
                    </v-data-table>
                    <div class="d-flex align-items-center justify-content-end">
                        <span class="pt-3">{{ $t("TOTAL") }}: {{ $tc("BOOKING_CAP", detailData.bookingGroupDTOS.length)
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
        <confirm-dialog @deleteItem="reSync" :maxWidth="325" :persistent="true" ref="reSyncDialogComponent">
            <span slot="title">{{ $t("CONFIRM_RE_SYNC") }} booking: {{ bookingReSync ? bookingReSync.otaBookingCode :
            null }}</span>
        </confirm-dialog>
        <v-dialog v-model="dialogEdit" v-if="!code" persistent width="1024">
            <v-card class="p-0">
                <v-card-title class="p-3 pb-0">
                    <span class="fs-14">{{ $t('UPDATE_INFO_BOOKING_GROUP') }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-form ref="form-info" lazy-validation>
                    <v-container class="px-3" id="d-group-profile-detail" style="height: 400px; overflow-y: auto">
                        <v-menu :close-on-content-click="false" :nudge-width="200" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn outlined small text color="indigo" class="mb-2" v-bind="attrs" v-on="on" x-small>
                                    {{ $t('_GROUP.CHOOSE_PROFILE') }} <i class="icon-drop-down-list fs-14 ml-2"></i>
                                </v-btn>
                            </template>

                            <v-card>
                                <v-list>
                                    <v-list-item class="px-2">
                                        <b-form-input v-model="textSearch"
                                            :placeholder="$t('_HOTEL_CHAIN.SEARCH')"></b-form-input>
                                    </v-list-item>
                                </v-list>
                                <v-list style="height: 300px; overflow-y: auto">
                                    <v-list-item
                                        v-for="pro in profiles.filter(item => item.nameVi.toString().toLowerCase().includes(textSearch.toLowerCase()))"
                                        style="min-height: 28px !important" class="px-2">
                                        <b-form-radio v-model="groupProfileId" :value="pro.id">
                                            <div class=" text-truncate" style="max-width: 150px;">{{
                                                pro.nameVi }}</div>
                                        </b-form-radio>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="profiles.filter(item => item.nameVi.toString().toLowerCase().includes(textSearch.toLowerCase())).length === 0">
                                        {{ $t('NO_DATA') }}
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-menu>
                        <div class="d-flex fs-12">
                            <div class="w-100">
                                <label class="label-title">{{ $t("_GROUP.INFO") }}</label>
                                <div class="pl-3">
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{
                                            $t("_BOOKING_GROUP.GROUP_PROFILE_NAME") }} *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.nameVi" :rules="ruleName" outlined dense
                                                counter maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{
                                            $t("_BOOKING_GROUP.GROUP_PROFILE_CODE") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.bookingGroupProfileCode" disabled outlined
                                                dense counter maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_GROUP.COMPANY_NAME")
                                        }} *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.company" outlined dense counter
                                                maxlength="250" :rules="ruleName">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_REGISTER.WEBSITE") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.website" outlined dense counter
                                                maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                            <v-divider vertical style="margin: 0 10px !important"></v-divider>
                            <div class="w-100">
                                <label class="label-title">{{ $t("_GROUP.INFO_MANAGE") }}</label>
                                <div class="pl-3">
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_GROUP.TITLE") }}</v-col>
                                        <v-col class="py-0">
                                            <v-autocomplete v-model="editedItem.managerTitle" :items="titles" outlined dense
                                                class="c-title" item-text="text" item-value="value"></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_GROUP.MANAGE_NAME")
                                        }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.managerName" outlined dense counter
                                                maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_GROUP.PHONE_NUMBER")
                                        }} </v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.managerPhone" outlined dense counter
                                                :rules="rulePhone" maxlength="100">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{
                                            $t("_GROUP.PHONE_NUMBER_OTHER") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.managerMobile" outlined dense counter
                                                :rules="rulePhone" maxlength="100">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">Email </v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.managerEmail" outlined dense counter
                                                :rules="ruleEmailNotRequied" maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                        <v-divider></v-divider>
                        <label class="label-title">{{ $t("_BOOKING_DETAIL.CONTACT.TITLE") }}</label>
                        <div class="d-flex fs-12">
                            <div class="w-100">
                                <div class="pl-3">
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_GROUP.TITLE") }}</v-col>
                                        <v-col class="py-0">
                                            <v-autocomplete v-model="editedItem.contactTitle" :items="titles" outlined dense
                                                class="c-title" item-text="text" item-value="value"></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_GROUP.CONTACT_NAME") }} *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactName" :rules="ruleName" outlined dense
                                                counter maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_GROUP.PHONE_NUMBER") }} *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactPhone" outlined dense counter
                                                :rules="rulePhone.concat(ruleRequied)" maxlength="100">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("_GROUP.PHONE_NUMBER_OTHER") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactMobile" outlined dense counter
                                                :rules="rulePhone" maxlength="100">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">Email *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactEmail" outlined dense counter
                                                :rules="ruleEmail" maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                            <v-divider vertical style="margin: 0 10px !important"></v-divider>
                            <div class="w-100">
                                <div class="pl-3">
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("COUNTRY") }}</v-col>
                                        <v-col class="py-0">
                                            <vue-autosuggest
                                                class="input-suggest input-suggest-booking v-text-field--outlined"
                                                v-model="editedItem.contactCountry"
                                                componentAttrIdAutosuggest="demo-autosuggest"
                                                :section-configs="sectionConfigs" :should-render-suggestions="(size, loading) => size >= 0 && !loading && editedItem.contactCountry !== ''
                                                    " @selected="$event => editedItem.contactCountry = $event.item"
                                                :suggestions="[
                                                        {
                                                            data: select.countries
                                                                .filter((p) => {
                                                                    return p.name.toLowerCase().indexOf(editedItem.contactCountry ? editedItem.contactCountry.toLowerCase() : '') > -1;
                                                                })
                                                                .map((e) => e.name),
                                                        },
                                                    ]" ref="autocomplete">
                                                <template slot-scope="{ suggestion, index, cs }">
                                                    <div>{{ suggestion.item }}</div>
                                                </template>
                                            </vue-autosuggest>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("CITY") }}</v-col>
                                        <v-col class="py-0">
                                            <vue-autosuggest
                                                class="input-suggest input-suggest-booking v-text-field--outlined"
                                                v-model="editedItem.contactCity"
                                                componentAttrIdAutosuggest="demo-autosuggest"
                                                :section-configs="sectionConfigs" :should-render-suggestions="(size, loading) => size >= 0 && !loading && editedItem.contactCity !== ''
                                                    " @selected="$event => editedItem.contactCity = $event.item"
                                                :suggestions="[
                                                        {
                                                            data: select.cities
                                                                .filter((p) => {
                                                                    return p.name.toLowerCase().indexOf(editedItem.contactCity ? editedItem.contactCity.toLowerCase() : '') > -1;
                                                                })
                                                                .map((e) => e.name),
                                                        },
                                                    ]" ref="autocomplete">
                                                <template slot-scope="{ suggestion, index, cs }">
                                                    <div>{{ suggestion.item }}</div>
                                                </template>
                                            </vue-autosuggest>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("DISTRICT") }}</v-col>
                                        <v-col class="py-0">
                                            <vue-autosuggest
                                                class="input-suggest input-suggest-booking v-text-field--outlined"
                                                v-model="editedItem.contactDistrict"
                                                componentAttrIdAutosuggest="demo-autosuggest"
                                                :section-configs="sectionConfigs" :should-render-suggestions="(size, loading) => size >= 0 && !loading && editedItem.contactDistrict !== ''
                                                    " @selected="$event => editedItem.contactDistrict = $event.item"
                                                :suggestions="[
                                                        {
                                                            data: select.districts
                                                                .filter((p) => {
                                                                    return p.name.toLowerCase().indexOf(editedItem.contactDistrict ? editedItem.contactDistrict.toLowerCase() : '') > -1;
                                                                })
                                                                .map((e) => e.name),
                                                        },
                                                    ]" ref="autocomplete">
                                                <template slot-scope="{ suggestion, index, cs }">
                                                    <div>{{ suggestion.item }}</div>
                                                </template>
                                            </vue-autosuggest>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="5">{{ $t("ADDRESS") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactAddress" outlined dense counter
                                                maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                        <v-divider></v-divider>
                        <label class="label-title">{{ $t("_GROUP.PAYMENT_INFO") }}</label>
                        <div class="w-100">
                            <div class="w-100 d-flex">
                                <div class="pt-11">{{ $t("_GROUP.PAYMENT_METHOD_BOOKING_RETAIL") }}
                                </div>
                                <div class="mx-3 font-weight-bold">
                                    <v-autocomplete color="primary" item-text="text" item-value="value"
                                        :items="listPaymentMethod" v-model="detailData.bookingGroupPaymentType" outlined
                                        chips dense>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip color="primary">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </div>
                            </div>
                        </div>
                    </v-container>
                </v-form>
                <v-divider class="mb-0"></v-divider>
                <v-card-actions>
                    <span class="mr-5 fs-10">* Trường bắt buộc</span>
                    <v-spacer></v-spacer>

                    <v-btn color="blue-darken-1" variant="text" @click="dialogEdit = false">
                        {{ $t('CLOSE') }}
                    </v-btn>
                    <v-btn color="primary" variant="text" @click="updateBooking()">
                        {{ $t('SAVE') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div v-if="dialogEdit && code" class="fullscreen-overlay" @click.self="dialogEdit = false">
             <v-card class="alert-card" width="900">
                <v-card-title class="p-3 pb-0">
                    <span class="fs-14">{{ $t('UPDATE_INFO_BOOKING_GROUP') }}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-form ref="form-info" lazy-validation>
                    <v-container class="px-3" id="d-group-profile-detail" style="height: 400px; overflow-y: auto">
                        <v-menu :close-on-content-click="false" :nudge-width="200" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn outlined small text color="indigo" class="mb-2" v-bind="attrs" v-on="on" x-small>
                                    {{ $t('_GROUP.CHOOSE_PROFILE') }} <i class="icon-drop-down-list fs-14 ml-2"></i>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-list>
                                    <v-list-item class="px-2">
                                        <b-form-input v-model="textSearch"
                                            :placeholder="$t('_HOTEL_CHAIN.SEARCH')"></b-form-input>
                                    </v-list-item>
                                </v-list>
                                <v-list style="height: 300px; overflow-y: auto">
                                    <v-list-item
                                        v-for="pro in profiles.filter(item => item.nameVi.toString().toLowerCase().includes(textSearch.toLowerCase()))"
                                        style="min-height: 28px !important" class="px-2">
                                        <b-form-radio v-model="groupProfileId" :value="pro.id">
                                            <div class="text-truncate" style="max-width: 370px;">{{ pro.nameVi }}</div>
                                        </b-form-radio>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="profiles.filter(item => item.nameVi.toString().toLowerCase().includes(textSearch.toLowerCase())).length === 0">
                                        {{ $t('NO_DATA') }}
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-menu>
                        <div class="d-flex fs-12">
                            <div class="w-100">
                                <label class="label-title">{{ $t("_GROUP.INFO") }}</label>
                                <div class="pl-3">
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{
                                            $t("_BOOKING_GROUP.GROUP_PROFILE_NAME") }} *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.nameVi" :rules="ruleName" outlined dense
                                                counter maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{
                                            $t("_BOOKING_GROUP.GROUP_PROFILE_CODE") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.bookingGroupProfileCode" disabled outlined
                                                dense counter maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_GROUP.COMPANY_NAME")
                                        }} *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.company" outlined dense counter
                                                maxlength="250" :rules="ruleName">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_REGISTER.WEBSITE") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.website" outlined dense counter
                                                maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                            <v-divider vertical style="margin: 0 10px !important"></v-divider>
                            <div class="w-100">
                                <label class="label-title">{{ $t("_GROUP.INFO_MANAGE") }}</label>
                                <div class="pl-3">
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_GROUP.TITLE") }}</v-col>
                                        <v-col class="py-0">
                                            <v-autocomplete v-model="editedItem.managerTitle" :items="titles" outlined dense
                                                class="c-title" item-text="text" item-value="value"></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_GROUP.MANAGE_NAME")
                                        }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.managerName" outlined dense counter
                                                maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_GROUP.PHONE_NUMBER")
                                        }} </v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.managerPhone" outlined dense counter
                                                :rules="rulePhone" maxlength="100">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{
                                            $t("_GROUP.PHONE_NUMBER_OTHER") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.managerMobile" outlined dense counter
                                                :rules="rulePhone" maxlength="100">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">Email </v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.managerEmail" outlined dense counter
                                                :rules="ruleEmailNotRequied" maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                        <v-divider></v-divider>
                        <label class="label-title">{{ $t("_BOOKING_DETAIL.CONTACT.TITLE") }}</label>
                        <div class="d-flex fs-12">
                            <div class="w-100">
                                <div class="pl-3">
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_GROUP.TITLE") }}</v-col>
                                        <v-col class="py-0">
                                            <v-autocomplete v-model="editedItem.contactTitle" :items="titles" outlined dense
                                                class="c-title" item-text="text" item-value="value"></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_GROUP.CONTACT_NAME") }} *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactName" :rules="ruleName" outlined dense
                                                counter maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_GROUP.PHONE_NUMBER") }} *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactPhone" outlined dense counter
                                                :rules="rulePhone.concat(ruleRequied)" maxlength="100">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("_GROUP.PHONE_NUMBER_OTHER") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactMobile" outlined dense counter
                                                :rules="rulePhone" maxlength="100">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">Email *</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactEmail" outlined dense counter
                                                :rules="ruleEmail" maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                            <v-divider vertical style="margin: 0 10px !important"></v-divider>
                            <div class="w-100">
                                <div class="pl-3">
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("COUNTRY") }}</v-col>
                                        <v-col class="py-0">
                                            <vue-autosuggest
                                                class="input-suggest input-suggest-booking v-text-field--outlined"
                                                v-model="editedItem.contactCountry"
                                                componentAttrIdAutosuggest="demo-autosuggest"
                                                :section-configs="sectionConfigs" :should-render-suggestions="(size, loading) => size >= 0 && !loading && editedItem.contactCountry !== ''
                                                    " @selected="$event => editedItem.contactCountry = $event.item"
                                                :suggestions="[
                                                        {
                                                            data: select.countries
                                                                .filter((p) => {
                                                                    return p.name.toLowerCase().indexOf(editedItem.contactCountry ? editedItem.contactCountry.toLowerCase() : '') > -1;
                                                                })
                                                                .map((e) => e.name),
                                                        },
                                                    ]" ref="autocomplete">
                                                <template slot-scope="{ suggestion, index, cs }">
                                                    <div>{{ suggestion.item }}</div>
                                                </template>
                                            </vue-autosuggest>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("CITY") }}</v-col>
                                        <v-col class="py-0">
                                            <vue-autosuggest
                                                class="input-suggest input-suggest-booking v-text-field--outlined"
                                                v-model="editedItem.contactCity"
                                                componentAttrIdAutosuggest="demo-autosuggest"
                                                :section-configs="sectionConfigs" :should-render-suggestions="(size, loading) => size >= 0 && !loading && editedItem.contactCity !== ''
                                                    " @selected="$event => editedItem.contactCity = $event.item"
                                                :suggestions="[
                                                        {
                                                            data: select.cities
                                                                .filter((p) => {
                                                                    return p.name.toLowerCase().indexOf(editedItem.contactCity ? editedItem.contactCity.toLowerCase() : '') > -1;
                                                                })
                                                                .map((e) => e.name),
                                                        },
                                                    ]" ref="autocomplete">
                                                <template slot-scope="{ suggestion, index, cs }">
                                                    <div>{{ suggestion.item }}</div>
                                                </template>
                                            </vue-autosuggest>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("DISTRICT") }}</v-col>
                                        <v-col class="py-0">
                                            <vue-autosuggest
                                                class="input-suggest input-suggest-booking v-text-field--outlined"
                                                v-model="editedItem.contactDistrict"
                                                componentAttrIdAutosuggest="demo-autosuggest"
                                                :section-configs="sectionConfigs" :should-render-suggestions="(size, loading) => size >= 0 && !loading && editedItem.contactDistrict !== ''
                                                    " @selected="$event => editedItem.contactDistrict = $event.item"
                                                :suggestions="[
                                                        {
                                                            data: select.districts
                                                                .filter((p) => {
                                                                    return p.name.toLowerCase().indexOf(editedItem.contactDistrict ? editedItem.contactDistrict.toLowerCase() : '') > -1;
                                                                })
                                                                .map((e) => e.name),
                                                        },
                                                    ]" ref="autocomplete">
                                                <template slot-scope="{ suggestion, index, cs }">
                                                    <div>{{ suggestion.item }}</div>
                                                </template>
                                            </vue-autosuggest>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="py-0 pt-11" cols="4">{{ $t("ADDRESS") }}</v-col>
                                        <v-col class="py-0">
                                            <v-text-field v-model="editedItem.contactAddress" outlined dense counter
                                                maxlength="250">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                        <v-divider></v-divider>
                        <label class="label-title">{{ $t("_GROUP.PAYMENT_INFO") }}</label>
                        <div class="w-100">
                            <div class="w-100 d-flex">
                                <div class="pt-11">{{ $t("_GROUP.PAYMENT_METHOD_BOOKING_RETAIL") }}
                                </div>
                                <div class="mx-3 font-weight-bold">
                                    <v-autocomplete color="primary" item-text="text" item-value="value"
                                        :items="listPaymentMethod" v-model="detailData.bookingGroupPaymentType" outlined
                                        chips dense>
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip color="primary">
                                                <span>{{ item.text }}</span>
                                            </v-chip>
                                        </template>
                                    </v-autocomplete>
                                </div>
                            </div>
                        </div>



                    </v-container>
                </v-form>
                <v-divider class="mb-0"></v-divider>
                <v-card-actions>
                    <span class="mr-5 fs-10">* Trường bắt buộc</span>
                    <v-spacer></v-spacer>

                    <v-btn color="blue-darken-1" variant="text" @click="dialogEdit = false">
                        {{ $t('CLOSE') }}
                    </v-btn>
                    <v-btn color="primary" variant="text" @click="updateBooking()">
                        {{ $t('SAVE') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
        <div v-if="reportBookingDialog" class="fullscreen-overlay" @click.self="reportBookingDialog = false">
            <v-card class="alert-card p-0" width="325" style="border-radius: 5px;">
                <v-toolbar class="toolbar-update" dense>
                <v-toolbar-title 
                class="text-primary fs-15 d-block px-2 py-3" 
                style="background: #e2e9f3; border-top-left-radius: 5px; border-top-right-radius: 5px;"
                >
                    <strong>{{$t('NOTIFICATION')}}</strong>
                </v-toolbar-title>
                </v-toolbar>
                <div class="content-update">
                    <label class="s-label">
                        {{ $t("CONFIRM_RE_SYNC") }} booking: {{ bookingReSync ? bookingReSync.otaBookingCode : null }}
                    </label>
                    <div class="mt-3 d-flex justify-content-between">
                        <div class="w-100 mr-1">
                            <v-btn depressed block @click="reportBookingDialog = false">
                                {{ $t("_LOGIN.CANCEL") }}
                            </v-btn>
                        </div>
                        <div class="w-100 ml-1">
                            <v-btn block color="primary" @click="reSync(bookingReSync)">
                                {{ $t("CONFIRM") }}
                            </v-btn>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>
        <v-navigation-drawer
            v-model="showDetail"
            absolute
            temporary
            right
            width="1000"
            >
            <booking-detail 
            v-if="showDetail" 
            :code="childCode" 
            @close="()=> {showDetail = false; $emit('closeChildDetail');}"
            ></booking-detail>
        </v-navigation-drawer>
    </div>
</template>
<style lang="scss">
#d-group-booking-detail {
    
    .theme--light.v-pagination .v-pagination__navigation {
        box-shadow: none !important;
    }

    .theme--light.v-pagination .v-pagination__item {
        box-shadow: none !important;
        font-size: 12px;
        margin: 0 !important;
    }

    .theme--light.v-pagination .v-pagination__item--active {
        color: #003e94 !important;
        background-color: transparent !important;
    }

    .v-pagination {
        justify-content: end !important;
    }
}
#d-group-profile-detail {
    .v-input .v-text-field__details {
        display: block;

        .v-counter {
            text-align: right;
            margin-top: 5px;
        }
    }

    .pt-11 {
        padding-top: 11px !important;
    }
}
</style>
<script>
import { service } from "@/_services/Group/group.service.js";
import moment from "moment";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import {
    _alert,
    _formatCurrency
} from "@/_helpers/function.js";
import { systemService } from "@/_services/system-data.service.js";
import BookingDetail from '../Booking/BookingDetail.vue';
export default {
    props: {
        code: {
        type: [String, Number],
        default: null,
        },
    },
    components: {
        "confirm-dialog": ConfirmDialog,
        BookingDetail,
    },
    data() {
        return {
            isLoading: true,
            systemLang: this.$i18n.locale,
            detailData: {},
            listStatus: [
                {
                    value: 0,
                    text: this.$t("_GROUP_STATUS.HOLD")
                },
                {
                    value: 1,
                    text: this.$t("_GROUP_STATUS.TENTATIVE")
                },
                {
                    value: 2,
                    text: this.$t("_GROUP_STATUS.CONFIRMED")
                },
                {
                    value: 3,
                    text: this.$t("_GROUP_STATUS.CANCELED")
                },
                {
                    value: 4,
                    text: this.$t("_GROUP_STATUS.NO_SHOW")
                },
                {
                    value: 5,
                    text: this.$t("_GROUP_STATUS.CHECKED_IN")
                },
                {
                    value: 6,
                    text: this.$t("_GROUP_STATUS.CHECKED_OUT")
                },
                {
                    value: 7,
                    text: this.$t("_GROUP_STATUS.CLOSE")
                },
            ],
            page: 1,
            pageCount: 0,
            listBookingStatus: [
                {
                    value: 0,
                    text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
                    color: "rgb(254, 209, 47)"
                },
                {
                    value: 1,
                    text: this.$t("_BOOKING.STATUS.CONFIRM"),
                    color: "#0da313"
                },
                {
                    value: 2,
                    text: this.$t("_BOOKING.STATUS.CANCEL"),
                    color: "#808080"
                },
                {
                    value: 3,
                    text: this.$t("_BOOKING.STATUS.VOID"),
                    color: "#262626"
                },
                {
                    value: 4,
                    text: this.$t("_BOOKING.STATUS.IN_SERVICE"),
                    color: "#262626"
                },
                {
                    value: 5,
                    text: this.$t("_BOOKING.STATUS.CLOSE"),
                    color: "#262626"
                },
                {
                    value: 6,
                    text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
                    color: "#ff0000"
                },
                {
                    value: 7,
                    text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
                    color: "#fed12f"
                },
            ],
            listCheckinStatus: [
                {
                    value: 0,
                    text: this.$t("CHECKIN_STATUS_RESERVED")
                },
                {
                    value: 1,
                    text: this.$t("CHECKIN_STATUS_CHECKIN")
                },
                {
                    value: 2,
                    text: this.$t("CHECKIN_STATUS_CHECKOUT")
                },
                {
                    value: 3,
                    text: this.$t("CHECKIN_STATUS_NO_SHOW")
                },
                {
                    value: 4,
                    text: this.$t("CHECKIN_STATUS_ARRIVAL")
                },
                {
                    value: 5,
                    text: this.$t("CHECKIN_STATUS_DUE_OUT")
                },
                {
                    value: 6,
                    text: this.$t("CHECKIN_STATUS_CANCELLED")
                },
            ],
            bookingReSync: null,
            listPaymentMethod: [
                {
                    value: 0,
                    text: this.$t("_GROUP.LEADER_NOT_PAY")
                },
                {
                    value: 1,
                    text: this.$t("_GROUP.LEADER_PAY_ONE_PART")
                },
                {
                    value: 2,
                    text: this.$t("_GROUP.LEADER_PAYS_ALL")
                },
            ],
            profiles: [],
            textSearch: '',
            dialogEdit: false,
            editedItem: {
                id: "",
                nameVi: "",
                bookingGroupProfileCode: "",
                descriptionVi: "",
                website: "",
                company: "",
                contactName: "",
                contactTitle: "",
                contactEmail: "",
                contactPhone: "",
                contactMobile: "",
                contactAddress: "",
                contactCountry: "",
                contactCity: "",
                contactDistrict: "",
                contactDescription: "",
                managerName: "",
                managerTitle: "",
                managerEmail: "",
                managerPhone: "",
                managerMobile: ""
            },
            select: {
                countries: [],
                cities: [],
                districts: [],
                wards: []
            },
            locations: [],
            locations: [],
            lang: this.$i18n.locale,
            country: null,
            city: null,
            district: null,
            groupProfileId: null,
            expanded: [],
            singleExpand: false,
            idEdit: null,
            titles: [],
            sectionConfigs: {
                default: {
                    limit: 4,
                    ulClass: { "data-darren": true },
                    liClass: { "elf-row": true },
                },
                Elf: {
                    limit: 6,
                },
            },
            reportBookingDialog: false,
            showDetail: false,
            childCode: null,
            currentRoute: this.$route.path,
        }
    },
    created() {
        this.getAllGroupProfile();
        this.getTitle();
    },
    watch: {
        showDetail() {
            if(this.showDetail == false) {
                history.pushState(null, '', `${this.currentRoute}`);
                this.$emit('closeChildDetail');
            }
        },
        groupProfileId(value) {
            if (value) {
                this.detailData.groupProfile = JSON.parse(JSON.stringify(this.editedItem));
                for (const key in this.editedItem) {
                    this.editedItem[`${key}`] = JSON.parse(JSON.stringify(this.profiles.find(e => e.id === value)))[`${key}`];
                    this.detailData.groupProfile[`${key}`] = JSON.parse(JSON.stringify(this.profiles.find(e => e.id === value)))[`${key}`];
                }
                this.editedItem['bookingGroupProfileCode'] = this.profiles.find(e => e.id === value).groupProfileCode;
            }
        }
    },
    methods: {
        _moment: moment,
        _formatDateTime(value, inputFormat, outputFormat) {
            if (!value) {
                return "";
            }
            return moment(value).format(outputFormat);
        },
        formatCurrency(amount) {
            return _formatCurrency(amount, 'VND');
        },
        async getTitle() {
            await service.getTitle().then(res => {
                if (res.responseCode == 0) {
                    this.titles = res.data.map(x => Object.assign({}, {
                        text: x,
                        value: x
                    }));

                }
            }).finally(() => (this.isLoading = false));
        },
        goToBookingDetail(code) {
            if (this.mobiTablet) {
                this.$router.push({ name: "bookingDetailMobile", params: { code: code } });
            } else {
                // this.$router.push({ name: "bookingDetail", params: { code: code } });
                this.childCode = code;
                const routeInfo = this.$router.resolve({ 
                name: "bookingDetail",
                params: { code: code } 
                });
                history.pushState(null, '', routeInfo.href);
                this.showDetail = true;
                this.$emit('showChildDetail');
            }
        },
        editProfile() {
            this.dialogEdit = true;
            if (this.detailData.bookingGroupProfile) {
                for (const key in this.editedItem) {
                    this.editedItem[`${key}`] = this.detailData.bookingGroupProfile[`${key}`]
                }
                this.idEdit = JSON.parse(JSON.stringify(this.detailData.bookingGroupProfile.id))
            }
        },
        getDetailBookingGroup() {
            this.isLoading = true
            let code = this.code || this.$route.params.code
            this.isEdit = true;
            service.getDetailBookingGroup(code).then((res) => {
                this.detailData = res.data;
                if (this.detailData.groupProfile) {
                    this.groupProfileId = this.detailData.groupProfile.id
                }

            }).finally(() => (this.getLocation()));
        },
        openPopupReSync(item) {
            this.bookingReSync = item
            if (this.code) {
                this.reportBookingDialog = true;
            } else {
                this.$refs.reSyncDialogComponent.open(item)
            }
        },
        reSync(item) {
            this.reportBookingDialog = false;
            const body = {
                bookingCode: item.bookingCode
            };
            chainService.reSync(body).then(res => {
                _alert(res, this.$t(res.data), false);
            });
        },
        getAllGroupProfile() {
            service
                .getAllGroupProfile()
                .then(res => {
                    if (res.responseCode === 0) {
                        this.profiles = res.data;

                    } else {
                        _alert(res, this.$t(res.data), false);
                    }
                })
                .finally(() => (this.getDetailBookingGroup()));
        },
        updateBooking() {
            let form_validate = this.$refs['form-info'].validate();

            if (!form_validate) {
                store.commit("alert/display", {
                    message: this.$t('_VALIDATE.REQUIRED'),
                    error: true,
                    success: false,
                });
                const el = document.querySelector(".v-messages.error--text:first-of-type");
                el.scrollIntoView();
                return false;
            }
            if (form_validate) {
                this.isLoading = true;
                this.editedItem['id'] = this.idEdit;
                const body = Object.assign({}, {
                    id: this.detailData.id,
                    bookingGroupCode: this.detailData.bookingGroupCode,
                    bookingGroupProfile: JSON.parse(JSON.stringify(this.editedItem)),
                    groupProfile: JSON.parse(JSON.stringify(this.detailData.groupProfile)),
                    bookingGroupPaymentType: this.detailData.bookingGroupPaymentType
                });
                if (body.bookingGroupProfile.groupProfileCode) {
                    delete body.bookingGroupProfile.groupProfileCode;
                    delete body.groupProfile.bookingGroupProfileCode;
                }
                service
                    .updateBooking(body)
                    .then(res => {
                        if (res.responseCode === 0) {
                            _alert(res, this.$t(res.data), false);
                            this.getDetailBookingGroup();

                            this.isLoading = false;
                        } else {
                            _alert(res, this.$t(res.data), false);
                            this.isLoading = false;
                        }
                        this.dialogEdit = false
                    })
            }

        },
        async getLocation() {
            await systemService.getLocations().then(res => {
                this.locations = res.data;
                this.select.countries = res.data
                    .filter(x => !x.parent)
                    .map(x => {
                        return {
                            name: x.i18ns.find(x => x.lang == this.defaultI18n)
                                ? x.i18ns.find(x => x.lang == this.defaultI18n).name
                                : ""
                        };
                    });
                this.select.cities = this.locations
                    .filter(x => x.locType == 1)
                    .map(x => {
                        return {
                            name: x.i18ns.find(x => x.lang == this.defaultI18n)
                                ? x.i18ns.find(x => x.lang == this.defaultI18n).name
                                : ""
                        };
                    });
                this.select.districts = this.locations
                    .filter(x => x.locType == 2)
                    .map(x => {
                        return {
                            name: x.i18ns.find(x => x.lang == this.defaultI18n)
                                ? x.i18ns.find(x => x.lang == this.defaultI18n).name
                                : ""
                        };
                    });
            }).finally(() => (this.isLoading = false));
        },
    },
    computed: {
        dessertHeaders() {
            return [
                {
                    text: this.$t("STT"),
                    align: 'start',
                    sortable: false,
                    value: 'stt',
                },
                {
                    text: this.$t("SUB_BOOKING_CODE"),
                    value: "bookingGroupCode",
                },
                {
                    text: this.$t("NUMBER_OF_BOOKING"),
                    value: "totalBooking",
                    align: 'end',
                },

                {
                    text: this.$t("CHECKIN"),
                    value: "arrival",
                    align: 'end',
                },
                {
                    text: this.$t("CHECKOUT"),
                    value: "departure",
                    align: 'end',
                },
                {
                    text: "Cut of days",
                    value: "cutOffDay",
                    align: 'end',
                },
                {
                    text: "Cut of date",
                    value: "cutOffDate",
                    align: 'end',
                },
                {
                    text: this.$t("ROOM_OF_LEADER"),
                    value: "leader",
                },
                { text: '', value: 'data-table-expand' },
            ]
        },
        headerSub() {
            return [
                {
                    text: this.$t("STT"),
                    align: 'start',
                    sortable: false,
                    value: 'stt',
                },
                {
                    text: this.$t("BOOKING_CUSTOMER_NAME"),
                    value: "bookingCustomer",
                },
                {
                    text: this.$t("BOOKING_CODE_OTA"),
                    value: "otaBookingCode",
                    class: "text-center",
                },
                {
                    text: this.$t("_BOOKING.BOOKING_CODE"),
                    class: "text-center",
                    value: "bookingCode",
                },
                {
                    text: this.$t("_BOOKING.TIME_STAY"),
                    value: "timeStay",
                    class: "text-center"
                },
                {
                    text: this.$t("_BOOKING.AMOUNT"),
                    value: "totalAmount",
                    class: "text-right"
                },
                {
                    text: this.$t("_BOOKING_TRANSACTION.BOOKING_STATUS"),
                    align: 'center',
                    value: "bookingStatus",
                },
                {
                    text: this.$t("_BOOKING.CHECKIN_STATUS"),
                    align: 'center',
                    value: "checkInStatus",
                },
                {
                    text: this.$t("NUMBER_ROOM"),
                    align: 'end',
                    value: "rooms",
                },
                {
                    text: this.$t("NUMBER_NIGHT"),
                    align: 'end',
                    value: "nights",
                },
                {
                    text: this.$t("_BOOKING.BOOKING_DATE"),
                    value: "bookingDate",
                    align: 'end',
                },
                {
                    text: this.$t("_DASHBOARD.SYNC_PMS"),
                    value: "syncPms",
                    align: 'center',
                    sortable: false,
                },
            ];
        }
    },
}
</script>
